import { FaAws } from "react-icons/fa"
import { SiGooglecloud } from "react-icons/si"
import { SiKubernetes } from "react-icons/si"
import { FaJenkins } from "react-icons/fa"
import { FaDocker } from "react-icons/fa"
import { SiTerraform } from "react-icons/si"
import { SiAnsible } from "react-icons/si"
import { FaGitlab } from "react-icons/fa"
import { SiSelenium } from "react-icons/si"
import { FaGithub } from "react-icons/fa"
import { SiSonarqube } from "react-icons/si"
import { SiPrometheus } from "react-icons/si"
import { SiDjango } from "react-icons/si"
import { FaPython } from "react-icons/fa"
import { FaReact } from "react-icons/fa"
import { IoLogoJavascript } from "react-icons/io5"
import { SiSpring } from "react-icons/si"

const data = [
    {id: 1, icon: <FaAws/>, link: 'https://aws.amazon.com'},
    {id: 2, icon: <SiGooglecloud/>, link: 'https://cloud.google.com'},
    {id: 3, icon: <SiKubernetes/>, link: 'https://kubernetes.io'},
    {id: 4, icon: <FaJenkins/>, link: 'https://www.jenkins.io'},
    {id: 5, icon: <FaGitlab/>, link: 'https://about.gitlab.com'},
    {id: 6, icon: <FaDocker/>, link: 'https://www.docker.com'},
    {id: 7, icon: <SiTerraform/>, link: 'https://www.terraform.io'},
    {id: 8, icon: <SiAnsible/>, link: 'https://www.ansible.com'},
    {id: 9, icon: <SiSelenium/>, link: 'https://www.selenium.dev'},
    {id: 10, icon: <FaGithub/>, link: 'https://github.com'},
    {id: 11, icon: <SiSonarqube/>, link: 'https://www.sonarsource.com/products/sonarqube/'},
    {id: 12, icon: <SiPrometheus/>, link: 'https://prometheus.io'},
    {id: 13, icon: <SiDjango/>, link: 'https://www.djangoproject.com'},
    {id: 14, icon: <FaPython/>, link: 'https://www.python.org'},
    {id: 15, icon: <FaReact/>, link: 'https://react.dev'},
    {id: 16, icon: <IoLogoJavascript/>, link: 'https://www.javascript.com'},
    {id: 17, icon: <SiSpring/>, link: 'https://spring.io'},

]


// alternative whatsApp link
// https://wa.me/yournumber
// https://api.whatsapp.com/send/?phone=%2B233557097546


export default data